import {
    Bell,
    CircleCheckBig,
    Instagram,
    MessageSquare,
    MessagesSquare,
    Unlock,
    Megaphone,
    Reply,
    Users,
    BookOpenText,
} from "lucide-react";
import type { NotificationType } from "@/lib/db/schema";

/**
 * Single source of truth mapping each notification type to its fallback icon
 * (shown when the triggering user has no avatar). Typed as an exhaustive
 * `Record<NotificationType, …>` so adding a value to `notificationTypeEnum`
 * without updating this map is a compile error in every consumer.
 *
 * Consumers: notification-bell.tsx, notification-list.tsx.
 */
export const TYPE_ICON: Record<NotificationType, typeof Bell> = {
    chapter_comment: MessageSquare,
    chapter_unlock: Unlock,
    admin_message: Megaphone,
    comment_reply: Reply,
    instagram_post_ready: Instagram,
    instagram_review_comment: MessagesSquare,
    instagram_post_approved: CircleCheckBig,
    fan_club_announcement: Users,
    fan_club_chapter_release: BookOpenText,
};

export { Bell };
